type GtmEvent =
  | 'inscription'
  | 'reservation_cours'
  | 'annulation_cours'
  | 'achat_cours_unite'
  | 'abonnement_engagement'
  | 'abonnement_sans_engagement'

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
    fbq?: (...args: unknown[]) => void
  }
}

class GtmService {
  private pushEvent(event: GtmEvent, data?: Record<string, unknown>): void {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event,
        ...data,
      })
    }
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', event, data)
    }
  }

  public trackRegistrationSuccess(): void {
    this.pushEvent('inscription')
  }

  public trackCourseReservationSuccess(): void {
    this.pushEvent('reservation_cours')
  }

  public trackCourseReservationCancel(): void {
    this.pushEvent('annulation_cours')
  }

  public trackCourseUnitPurchaseSuccess(): void {
    this.pushEvent('achat_cours_unite')
  }

  public trackSubscriptionWithEngagementSuccess(): void {
    this.pushEvent('abonnement_engagement')
  }

  public trackSubscriptionWithoutEngagementSuccess(): void {
    this.pushEvent('abonnement_sans_engagement')
  }
}

export const gtmService = new GtmService()
